// Skirmshop Chatbot Widget — Floating popup
(function() {
  'use strict';

  var config = window.__SKIRMSHOP_WIDGET_CONFIG || {};
  var API_URL = config.apiUrl || '';
  var LOCALE = (config.locale || 'es').slice(0, 2);

  // ─── DOM ───
  var btn = document.getElementById('CwBtn');
  var panel = document.getElementById('CwPanel');
  var messagesEl = document.getElementById('CwMessages');
  var inputEl = document.getElementById('CwInput');
  var sendBtn = document.getElementById('CwSend');
  var closeBtn = document.getElementById('CwClose');
  var expandBtn = document.getElementById('CwExpand');
  var toastEl = document.getElementById('CwToast');
  if (!btn || !panel) return;

  // ─── State ───
  var widgetOpen = false;
  var supportSessionToken = null;
  try {
    supportSessionToken = sessionStorage.getItem('skirmshop_support_session');
  } catch(e) {}
  var chatHistory = [];
  var sending = false;
  var pageContext = null;
  var initialized = false;
  var currentProductHandle = null; // Track product to detect navigation
  var greetingShown = false;
  var greetingTimeout = null;

  // ─── Markdown → HTML ───
  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function stripToolCalls(text) {
    return text.replace(/\[TOOL:[^\]]*\]/g, '').replace(/  +/g, ' ').trim();
  }

  function formatBot(raw) {
    var text = stripToolCalls(raw);
    if (!text) return '';
    var e = escapeHtml(text);
    e = e.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    var lines = e.split('\n'), html = [], inUl = false, inOl = false;
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      var ulM = line.match(/^[-•]\s+(.+)/);
      var olM = line.match(/^\d+[.)]\s+(.+)/);
      if (ulM) {
        if (!inUl) { if (inOl) { html.push('</ol>'); inOl = false; } html.push('<ul>'); inUl = true; }
        html.push('<li>' + ulM[1] + '</li>');
      } else if (olM) {
        if (!inOl) { if (inUl) { html.push('</ul>'); inUl = false; } html.push('<ol>'); inOl = true; }
        html.push('<li>' + olM[1] + '</li>');
      } else {
        if (inUl) { html.push('</ul>'); inUl = false; }
        if (inOl) { html.push('</ol>'); inOl = false; }
        if (line === '') html.push('<br>');
        else html.push('<p>' + line + '</p>');
      }
    }
    if (inUl) html.push('</ul>');
    if (inOl) html.push('</ol>');
    return html.join('');
  }

  // ─── Page Context Detection ───
  function detectPageContext() {
    var path = window.location.pathname;
    // Strip locale prefix (e.g. /en/products/x → /products/x)
    var cleanPath = path.replace(/^\/(en|es|fr|de|it|pt|nl|pl|sv|ja|zh|el|cs|hu|ro|bg|hr|uk|ru|tr|ca)(\/|$)/, '/');
    var ctx = { url: cleanPath, title: document.title, type: 'page' };

    // Product page
    var prodMatch = cleanPath.match(/\/products\/([\w-]+)/);
    if (prodMatch) {
      ctx.type = 'product';
      ctx.productHandle = prodMatch[1];
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.product) {
        ctx.productHandle = meta.product.handle || ctx.productHandle;
      }
      // Try embedded product JSON (Concept theme uses data-product-json)
      var jsonEl = document.querySelector('script[type="application/json"][data-product-json], [data-product-json] script[type="application/json"]');
      if (jsonEl) {
        try {
          var p = JSON.parse(jsonEl.textContent);
          ctx.productTitle = p.title;
          ctx.productHandle = p.handle || ctx.productHandle;
          ctx.productPrice = p.price ? (p.price / 100).toFixed(2) : undefined;
          ctx.productVendor = p.vendor;
          ctx.productAvailable = p.available;
          ctx.productDescription = (p.description || '').replace(/<[^>]*>/g, '').substring(0, 300);
          ctx.productVariants = (p.variants || []).map(function(v) { return v.title; }).filter(function(t) { return t !== 'Default Title'; }).join(', ');
        } catch(e) {}
      }
      // Fallback: read from page elements
      if (!ctx.productTitle) {
        var h1 = document.querySelector('h1');
        if (h1) ctx.productTitle = h1.textContent.trim();
      }
    }

    // Collection page
    var collMatch = cleanPath.match(/\/collections\/([\w-]+)/);
    if (collMatch && ctx.type !== 'product') {
      ctx.type = 'collection';
      ctx.collectionHandle = collMatch[1];
      var h1c = document.querySelector('h1');
      if (h1c) ctx.collectionTitle = h1c.textContent.trim();
    }

    return ctx;
  }

  // Reset widget state for a fresh conversation
  function resetConversation() {
    supportSessionToken = null;
    try { sessionStorage.removeItem('skirmshop_support_session'); } catch(e) {}
    chatHistory = [];
    // Clear messages UI
    while (messagesEl.firstChild) messagesEl.removeChild(messagesEl.firstChild);
  }

  function initSession(cb) {
    // Shopify signs logged-in identity on every App Proxy request. The browser
    // keeps only the opaque session token minted by the deterministic gateway.
    cb();
  }

  // ─── UI Helpers ───
  function appendMsg(role, text) {
    var div = document.createElement('div');
    div.className = 'cw-msg cw-msg--' + (role === 'user' ? 'user' : 'bot');
    if (role === 'user') div.textContent = text;
    else div.innerHTML = formatBot(text);
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function showTyping() {
    var div = document.createElement('div');
    div.className = 'cw-typing'; div.id = 'CwTyping';
    for (var i = 0; i < 3; i++) div.appendChild(document.createElement('span'));
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }
  function hideTyping() {
    var t = document.getElementById('CwTyping');
    if (t && t.parentNode) t.parentNode.removeChild(t);
  }

  function showToast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    setTimeout(function() { toastEl.classList.remove('is-visible'); }, 2500);
  }

  // ─── Product Card ───
  function renderProductCard(data) {
    var card = document.createElement('div');
    card.className = 'cw-product';
    var product = data.product;
    if (!product) return card;
    var imgSrc = product.image || (product.images && product.images[0]) || '';
    var html = '';
    if (imgSrc) html += '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
    html += '<div class="cw-product-body">';
    html += '<div class="cw-product-title"><a href="/products/' + escapeHtml(product.handle) + '" target="_blank">' + escapeHtml(product.title) + '</a></div>';
    html += '<div class="cw-product-price">' + escapeHtml(product.price || '') + ' ' + escapeHtml(product.currency || 'EUR') + '</div>';
    // Stock indicator
    if (product.totalInventory !== undefined) {
      if (product.lowStock) {
        html += '<div class="cw-stock cw-stock--low">⚠️ ' + (LOCALE === 'es' ? 'Solo quedan ' + product.totalInventory + '!' : 'Only ' + product.totalInventory + ' left!') + '</div>';
      } else if (!product.available) {
        html += '<div class="cw-stock cw-stock--out">❌ ' + (LOCALE === 'es' ? 'Agotado' : 'Out of stock') + '</div>';
      } else {
        html += '<div class="cw-stock cw-stock--ok">✅ ' + (LOCALE === 'es' ? 'En stock' : 'In stock') + '</div>';
      }
    }
    html += '<div class="cw-product-actions">';
    if (product.available) {
      html += '<button class="cw-product-add" data-variant="' + (product.variantId || '') + '">Add</button>';
    } else {
      html += '<button class="cw-product-add sold-out" disabled>Sold out</button>';
    }
    html += '<a class="cw-product-view" href="/products/' + escapeHtml(product.handle) + '" target="_blank">View</a>';
    html += '</div></div>';
    card.innerHTML = html;
    var addBtn = card.querySelector('.cw-product-add[data-variant]');
    if (addBtn && product.available) {
      addBtn.addEventListener('click', function() {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: product.variantId, quantity: 1 }),
        }).then(function(r) {
          if (r.ok) showToast('Added to cart');
          else showToast('Error');
        }).catch(function() { showToast('Error'); });
      });
    }
    messagesEl.appendChild(card);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return card;
  }

  // ─── Collection Card ───
  function renderCollectionCard(data) {
    var coll = data.collection;
    if (!coll) return;
    var a = document.createElement('a');
    a.className = 'cw-collection';
    a.href = '/collections/' + (coll.handle || '');
    a.target = '_blank';
    var html = '';
    if (coll.image) html += '<img src="' + escapeHtml(coll.image) + '" alt="' + escapeHtml(coll.title) + '">';
    html += '<div class="cw-collection-info"><div class="cw-collection-title">' + escapeHtml(coll.title) + '</div>';
    html += '<div class="cw-collection-count">' + (coll.productsCount || '') + ' products</div></div>';
    a.innerHTML = html;
    messagesEl.appendChild(a);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Cart Rendering ───
  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(cart) { cb(cart); })
      .catch(function() { cb(null); });
  }

  function renderCartCard(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      appendMsg('bot', LOCALE === 'es' ? 'Tu carrito está vacío.' : 'Your cart is empty.');
      return;
    }
    var div = document.createElement('div');
    div.className = 'cw-cart';
    var header = document.createElement('div');
    header.className = 'cw-cart-header';
    header.textContent = (LOCALE === 'es' ? 'Tu Carrito' : 'Your Cart') + ' (' + cart.item_count + ')';
    div.appendChild(header);

    cart.items.forEach(function(item) {
      var row = document.createElement('div');
      row.className = 'cw-cart-item';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image.replace(/(\.\w+)$/, '_small$1');
        img.alt = item.title;
        row.appendChild(img);
      }
      var info = document.createElement('div');
      info.className = 'cw-cart-item-info';
      var name = document.createElement('div');
      name.className = 'cw-cart-item-name';
      name.textContent = item.title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'cw-cart-item-meta';
      meta.textContent = 'x' + item.quantity + ' · ' + (item.final_line_price / 100).toFixed(2) + ' EUR';
      info.appendChild(meta);
      row.appendChild(info);

      var removeBtn = document.createElement('button');
      removeBtn.className = 'cw-cart-remove';
      removeBtn.textContent = '×';
      removeBtn.title = LOCALE === 'es' ? 'Eliminar' : 'Remove';
      (function(key) {
        removeBtn.addEventListener('click', function() {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          }).then(function() {
            showToast(LOCALE === 'es' ? 'Eliminado del carrito' : 'Removed from cart');
            fetchCart(function(updated) { if (div.parentNode) div.parentNode.removeChild(div); renderCartCard(updated); });
          });
        });
      })(item.key);
      row.appendChild(removeBtn);

      div.appendChild(row);
    });

    var footer = document.createElement('div');
    footer.className = 'cw-cart-footer';
    var total = document.createElement('span');
    total.textContent = 'Total: ' + (cart.total_price / 100).toFixed(2) + ' EUR';
    footer.appendChild(total);
    var checkoutBtn = document.createElement('a');
    checkoutBtn.href = '/checkout';
    checkoutBtn.className = 'cw-cart-checkout';
    checkoutBtn.textContent = 'Checkout →';
    footer.appendChild(checkoutBtn);
    div.appendChild(footer);

    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Wishlist Rendering ───
  function renderWishlistCard(items) {
    if (!items || items.length === 0) {
      appendMsg('bot', LOCALE === 'es' ? 'Tu lista de deseos está vacía.' : 'Your wishlist is empty.');
      return;
    }
    var div = document.createElement('div');
    div.className = 'cw-cart';
    var header = document.createElement('div');
    header.className = 'cw-cart-header';
    header.textContent = (LOCALE === 'es' ? 'Lista de Deseos' : 'Wishlist') + ' (' + items.length + ')';
    div.appendChild(header);

    items.forEach(function(item) {
      var row = document.createElement('div');
      row.className = 'cw-cart-item';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image.replace(/(\.\w+)$/, '_small$1');
        img.alt = item.productTitle;
        row.appendChild(img);
      }
      var info = document.createElement('div');
      info.className = 'cw-cart-item-info';
      var name = document.createElement('div');
      name.className = 'cw-cart-item-name';
      var link = document.createElement('a');
      link.href = '/products/' + item.productHandle;
      link.target = '_blank';
      link.textContent = item.productTitle;
      link.style.color = 'inherit';
      name.appendChild(link);
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'cw-cart-item-meta';
      var price = item.currentPrice ? parseFloat(item.currentPrice).toFixed(2) + ' EUR' : '';
      var stock = item.available ? (LOCALE === 'es' ? '✅ En stock' : '✅ In stock') : (LOCALE === 'es' ? '❌ Agotado' : '❌ Out of stock');
      meta.textContent = price + (price ? ' · ' : '') + stock;
      info.appendChild(meta);
      row.appendChild(info);
      div.appendChild(row);
    });

    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Stock Alert Rendering ───
  function renderStockAlerts(alerts) {
    if (!alerts || alerts.length === 0) {
      appendMsg('bot', LOCALE === 'es' ? 'No tienes alertas de stock activas.' : 'You have no active stock alerts.');
      return;
    }
    var div = document.createElement('div');
    div.className = 'cw-cart';
    var header = document.createElement('div');
    header.className = 'cw-cart-header';
    header.textContent = (LOCALE === 'es' ? 'Alertas de Stock' : 'Stock Alerts') + ' (' + alerts.length + ')';
    div.appendChild(header);

    alerts.forEach(function(alert) {
      var row = document.createElement('div');
      row.className = 'cw-cart-item';
      var info = document.createElement('div');
      info.className = 'cw-cart-item-info';
      var name = document.createElement('div');
      name.className = 'cw-cart-item-name';
      name.textContent = alert.productTitle;
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'cw-cart-item-meta';
      var statusIcon = alert.status === 'notified' ? '✅' : '⏳';
      var statusText = alert.status === 'notified' ? (LOCALE === 'es' ? 'Disponible!' : 'Available!') : (LOCALE === 'es' ? 'Esperando...' : 'Waiting...');
      meta.textContent = statusIcon + ' ' + statusText;
      info.appendChild(meta);
      row.appendChild(info);
      div.appendChild(row);
    });

    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Shipping Card ───
  function renderShippingCard(methods, country) {
    if (!methods || methods.length === 0) {
      appendMsg('bot', LOCALE === 'es' ? 'No hay métodos de envío disponibles para este destino.' : 'No shipping methods available for this destination.');
      return;
    }
    var div = document.createElement('div');
    div.className = 'cw-cart';
    var header = document.createElement('div');
    header.className = 'cw-cart-header';
    header.textContent = (LOCALE === 'es' ? 'Envío a ' : 'Shipping to ') + (country || '').toUpperCase();
    div.appendChild(header);

    methods.forEach(function(m) {
      var row = document.createElement('div');
      row.className = 'cw-cart-item';
      var info = document.createElement('div');
      info.className = 'cw-cart-item-info';
      var name = document.createElement('div');
      name.className = 'cw-cart-item-name';
      name.textContent = m.carrier + ' — ' + m.name;
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'cw-cart-item-meta';
      meta.textContent = parseFloat(m.price).toFixed(2) + ' EUR · ' + m.minDays + '-' + m.maxDays + (LOCALE === 'es' ? ' días' : ' days');
      info.appendChild(meta);
      row.appendChild(info);
      div.appendChild(row);
    });

    var footer = document.createElement('div');
    footer.className = 'cw-cart-footer';
    var note = document.createElement('span');
    note.style.fontSize = '11px';
    note.style.color = '#888';
    note.textContent = LOCALE === 'es' ? 'Envío gratis a partir de 100€' : 'Free shipping over €100';
    footer.appendChild(note);
    div.appendChild(footer);

    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Discount Card ───
  function renderDiscountCard(discounts) {
    if (!discounts || discounts.length === 0) {
      appendMsg('bot', LOCALE === 'es' ? 'No hay códigos de descuento activos en este momento.' : 'No active discount codes at this time.');
      return;
    }
    var div = document.createElement('div');
    div.className = 'cw-cart';
    var header = document.createElement('div');
    header.className = 'cw-cart-header';
    header.textContent = LOCALE === 'es' ? 'Descuentos Activos' : 'Active Discounts';
    div.appendChild(header);

    discounts.forEach(function(d) {
      var row = document.createElement('div');
      row.className = 'cw-cart-item';
      var info = document.createElement('div');
      info.className = 'cw-cart-item-info';
      var name = document.createElement('div');
      name.className = 'cw-cart-item-name';
      name.textContent = d.code + ' — ' + d.value + (d.type === 'percentage' ? ' off' : '');
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'cw-cart-item-meta';
      var parts = [];
      if (d.title && d.title !== d.code) parts.push(d.title);
      if (d.minimumSubtotal) parts.push((LOCALE === 'es' ? 'Mín: ' : 'Min: ') + d.minimumSubtotal + '€');
      if (d.endsAt) parts.push((LOCALE === 'es' ? 'Hasta: ' : 'Until: ') + new Date(d.endsAt).toLocaleDateString());
      meta.textContent = parts.join(' · ') || d.title;
      info.appendChild(meta);
      row.appendChild(info);
      div.appendChild(row);
    });

    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Comparison Card ───
  function renderComparisonCard(products) {
    if (!products || products.length < 2) return;
    var div = document.createElement('div');
    div.className = 'cw-cart';
    var header = document.createElement('div');
    header.className = 'cw-cart-header';
    header.textContent = LOCALE === 'es' ? 'Comparación de Productos' : 'Product Comparison';
    div.appendChild(header);

    products.forEach(function(p) {
      var row = document.createElement('div');
      row.className = 'cw-cart-item';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image.replace(/(\.\w+)$/, '_small$1');
        img.alt = p.title;
        row.appendChild(img);
      }
      var info = document.createElement('div');
      info.className = 'cw-cart-item-info';
      var name = document.createElement('div');
      name.className = 'cw-cart-item-name';
      var link = document.createElement('a');
      link.href = '/products/' + p.handle;
      link.target = '_blank';
      link.textContent = p.title;
      link.style.color = 'inherit';
      name.appendChild(link);
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'cw-cart-item-meta';
      var stock = p.available ? '✅' : '❌';
      meta.textContent = parseFloat(p.price).toFixed(2) + ' EUR · ' + stock + ' · ' + (p.totalInventory || 0) + (LOCALE === 'es' ? ' uds' : ' units');
      info.appendChild(meta);
      row.appendChild(info);
      div.appendChild(row);
    });

    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Return Card ───
  function renderReturnCard(ret) {
    if (!ret) return;
    var div = document.createElement('div');
    div.className = 'cw-cart';
    var header = document.createElement('div');
    header.className = 'cw-cart-header';
    header.textContent = (LOCALE === 'es' ? 'Devolución — ' : 'Return — ') + ret.orderName;
    div.appendChild(header);
    var row = document.createElement('div');
    row.className = 'cw-cart-item';
    var info = document.createElement('div');
    info.className = 'cw-cart-item-info';
    var name = document.createElement('div');
    name.className = 'cw-cart-item-name';
    name.textContent = (LOCALE === 'es' ? 'Estado: ' : 'Status: ') + ret.status;
    info.appendChild(name);
    var meta = document.createElement('div');
    meta.className = 'cw-cart-item-meta';
    meta.textContent = ret.message;
    meta.style.whiteSpace = 'normal';
    info.appendChild(meta);
    row.appendChild(info);
    div.appendChild(row);
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Send Message ───
  function sendMessage(message) {
    if (!message.trim() || sending) return;
    sending = true;
    sendBtn.disabled = true;

    // Always refresh page context before sending (SPA-like navigation)
    pageContext = detectPageContext();

    appendMsg('user', message);
    chatHistory.push({ role: 'user', content: message });
    inputEl.value = '';
    showTyping();

    // Fetch real cart data before sending to give LLM context
    fetchCart(function(cart) {
      var cartItems = [];
      if (cart && cart.items && cart.items.length > 0) {
        cartItems = cart.items.map(function(item) {
          return item.title + ' (x' + item.quantity + ', ' + (item.final_line_price / 100).toFixed(2) + ' EUR, key:' + item.key + ')';
        });
      }

      var body = {
        message: message,
        history: chatHistory.slice(-20),
        context: {
          cartItems: cartItems,
          locale: LOCALE,
          currentPage: pageContext,
        },
      };
      if (supportSessionToken) body.supportSessionToken = supportSessionToken;

      doSend(body);
    });
  }

  function doSend(body) {
    fetch(API_URL + '/chat', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function(res) {
      if (!res.ok) throw new Error('Chat failed');
      var issuedToken = res.headers.get('X-Support-Session');
      if (issuedToken) {
        supportSessionToken = issuedToken;
        try { sessionStorage.setItem('skirmshop_support_session', issuedToken); } catch(e) {}
      }
      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';
      var botBubble = null;
      var botText = '';
      var actionBubble = null;

      function pump() {
        return reader.read().then(function(result) {
          if (result.done) {
            hideTyping();
            if (actionBubble && actionBubble.parentNode) actionBubble.parentNode.removeChild(actionBubble);
            chatHistory.push({ role: 'assistant', content: botText || '[shown]' });
            sending = false;
            sendBtn.disabled = false;
            inputEl.focus();
            return;
          }
          buffer += decoder.decode(result.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            if (line.indexOf('event: ') === 0) {
              var evtType = line.slice(7).trim();
              i++;
              if (i >= lines.length || lines[i].indexOf('data: ') !== 0) continue;
              var data;
              try { data = JSON.parse(lines[i].slice(6)); } catch(e) { continue; }

              if (evtType === 'action') {
                hideTyping();
                if (!actionBubble) {
                  actionBubble = document.createElement('div');
                  actionBubble.className = 'cw-msg cw-msg--action';
                  messagesEl.appendChild(actionBubble);
                }
                actionBubble.textContent = data.text || 'Processing...';
                messagesEl.scrollTop = messagesEl.scrollHeight;
              } else if (evtType === 'token') {
                hideTyping();
                if (actionBubble && actionBubble.parentNode) { actionBubble.parentNode.removeChild(actionBubble); actionBubble = null; }
                if (!botBubble) {
                  botBubble = document.createElement('div');
                  botBubble.className = 'cw-msg cw-msg--bot';
                  messagesEl.appendChild(botBubble);
                }
                botText += data.text || '';
                botBubble.innerHTML = formatBot(botText);
                messagesEl.scrollTop = messagesEl.scrollHeight;
              } else if (evtType === 'tool_call') {
                if (actionBubble && actionBubble.parentNode) { actionBubble.parentNode.removeChild(actionBubble); actionBubble = null; }
                if (data.tool === 'show_product' && data.product) {
                  renderProductCard(data);
                } else if (data.tool === 'show_collection' && data.collection) {
                  renderCollectionCard(data);
                } else if (data.tool === 'show_cart') {
                  fetchCart(function(cart) { renderCartCard(cart); });
                } else if (data.tool === 'update_cart' && data.handle) {
                  var cartParts = data.handle.split(':');
                  var cartVid = cartParts[0];
                  var cartQty = parseInt(cartParts[1] || '0', 10);
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: cartVid, quantity: cartQty }),
                  }).then(function() {
                    showToast(cartQty === 0 ? (LOCALE === 'es' ? 'Eliminado del carrito' : 'Removed from cart') : (LOCALE === 'es' ? 'Carrito actualizado' : 'Cart updated'));
                    fetchCart(function(cart) { renderCartCard(cart); });
                  });
                } else if (data.tool === 'clear_cart') {
                  fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
                    .then(function() {
                      showToast(LOCALE === 'es' ? 'Carrito vaciado' : 'Cart cleared');
                      appendMsg('bot', LOCALE === 'es' ? 'Tu carrito ha sido vaciado.' : 'Your cart has been cleared.');
                    });
                } else if (data.tool === 'show_wishlist' && data.wishlistItems) {
                  renderWishlistCard(data.wishlistItems);
                } else if (data.tool === 'add_to_wishlist' && data.success) {
                  showToast(LOCALE === 'es' ? 'Guardado en tu lista de deseos' : 'Saved to wishlist');
                } else if (data.tool === 'remove_from_wishlist' && data.success) {
                  showToast(LOCALE === 'es' ? 'Eliminado de tu lista de deseos' : 'Removed from wishlist');
                } else if (data.tool === 'list_stock_alerts' && data.stockAlerts) {
                  renderStockAlerts(data.stockAlerts);
                } else if (data.tool === 'subscribe_stock' && data.success) {
                  showToast(LOCALE === 'es' ? 'Alerta de stock activada' : 'Stock alert activated');
                } else if (data.tool === 'cancel_stock_alert' && data.success) {
                  showToast(LOCALE === 'es' ? 'Alerta cancelada' : 'Alert cancelled');
                } else if (data.tool === 'show_shipping' && data.shippingMethods) {
                  renderShippingCard(data.shippingMethods, data.handle);
                } else if (data.tool === 'show_discounts' && data.discounts) {
                  renderDiscountCard(data.discounts);
                } else if (data.tool === 'apply_discount' && data.handle) {
                  window.location.href = '/discount/' + data.handle;
                } else if (data.tool === 'compare_products' && data.comparisonProducts) {
                  renderComparisonCard(data.comparisonProducts);
                } else if (data.tool === 'create_return' && data.returnData) {
                  renderReturnCard(data.returnData);
                } else if (data.tool === 'show_return_status' && data.returnData) {
                  renderReturnCard(data.returnData);
                }
              } else if (evtType === 'error') {
                hideTyping();
                appendMsg('bot', data.message || 'Error.');
              }
            }
          }
          return pump();
        });
      }
      return pump();
    }).catch(function(err) {
      hideTyping();
      appendMsg('bot', 'Service unavailable. Please try again.');
      console.error('Widget error:', err);
      sending = false;
      sendBtn.disabled = false;
    });
  }

  // ─── Open / Close ───
  function openWidget() {
    widgetOpen = true;
    panel.classList.add('is-open');
    btn.classList.add('is-hidden');

    // Always re-detect page context (user may have navigated)
    var newContext = detectPageContext();
    var newHandle = newContext.productHandle || null;
    var needsReset = initialized && newHandle !== currentProductHandle;

    pageContext = newContext;
    currentProductHandle = newHandle;

    if (!initialized || needsReset) {
      initialized = true;
      if (needsReset) resetConversation();
      initSession(function() {
        inputEl.focus();
      });
    } else {
      inputEl.focus();
    }
  }

  function closeWidget() {
    widgetOpen = false;
    panel.classList.remove('is-open');
    btn.classList.remove('is-hidden');
  }

  // ─── Proactive Greeting ───
  function showGreetingBubble(msg) {
    try { if (sessionStorage.getItem('cw_greeted')) return; } catch(e) {}
    var bubble = document.createElement('div');
    bubble.className = 'cw-greeting';
    bubble.textContent = msg;
    bubble.addEventListener('click', function() {
      dismissGreeting(bubble);
      openWidget();
    });
    var dismiss = document.createElement('button');
    dismiss.className = 'cw-greeting-close';
    dismiss.textContent = '×';
    dismiss.addEventListener('click', function(e) {
      e.stopPropagation();
      dismissGreeting(bubble);
    });
    bubble.appendChild(dismiss);
    btn.parentNode.insertBefore(bubble, btn);
    setTimeout(function() { dismissGreeting(bubble); }, 8000);
  }

  function dismissGreeting(bubble) {
    if (bubble && bubble.parentNode) bubble.parentNode.removeChild(bubble);
    try { sessionStorage.setItem('cw_greeted', '1'); } catch(e) {}
  }

  function scheduleGreeting() {
    if (greetingShown || greetingTimeout) return;
    var ctx = detectPageContext();
    if (ctx.type !== 'product' && ctx.type !== 'collection') return;
    try { if (!localStorage.getItem('skirmshop_widget_session')) return; } catch(e) { return; }
    try { if (sessionStorage.getItem('cw_greeted')) return; } catch(e) { return; }

    greetingTimeout = setTimeout(function() {
      if (widgetOpen || greetingShown) return;
      greetingShown = true;
      var msg = '';
      if (ctx.type === 'product' && ctx.productTitle) {
        msg = LOCALE === 'es'
          ? '¿Dudas sobre el ' + ctx.productTitle.substring(0, 40) + '? ¡Te ayudo!'
          : 'Questions about the ' + ctx.productTitle.substring(0, 40) + '? I can help!';
      } else if (ctx.type === 'collection' && ctx.collectionTitle) {
        msg = LOCALE === 'es'
          ? '¿Buscas algo en ' + ctx.collectionTitle.substring(0, 30) + '?'
          : 'Looking for something in ' + ctx.collectionTitle.substring(0, 30) + '?';
      }
      if (msg) showGreetingBubble(msg);
    }, 30000);
  }

  scheduleGreeting();

  // ─── Event Listeners ───
  btn.addEventListener('click', openWidget);
  closeBtn.addEventListener('click', closeWidget);
  expandBtn.addEventListener('click', function() {
    window.location.href = '/pages/ai';
  });

  inputEl.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      sendMessage(inputEl.value);
    }
  });
  sendBtn.addEventListener('click', function() {
    sendMessage(inputEl.value);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && widgetOpen) closeWidget();
  });
})();
